// 不同国家对应的问卷调查用到的选项

// 公司设立的原因
export const establishCauseData = {
  Singapore: [
    { value: "I reside in Singapore", zh: "我住在新加坡", en: "I reside in Singapore" },
    { value: "Expansion of existing business", zh: "现有业务的扩展", en: "Expansion of existing business" },
    { value: "Entering into Asia", zh: "进入亚洲市场", en: "Entering into Asia" },
    { value: "Requested by parties we work with", zh: "业务伙伴要求", en: "Requested by parties we work with" },
    {
      value: "Singapore is an international recognised hub",
      zh: "新加坡作为国际公认的枢纽，以新加坡为跳板进行海外业务扩展",
      en: "Singapore is an international recognised hub",
    },
    { value: "Others, please specify", zh: "其他方式，请列明", en: "Others, please specify" },
  ],
  Malaysia: [
    { value: "I reside in Malaysia", zh: "我住在马来西亚", en: "I reside in Malaysia" },
    { value: "Expansion of existing business", zh: "现有业务的扩展", en: "Expansion of existing business" },
    { value: "Entering into Asia", zh: "进入亚洲市场", en: "Entering into Asia" },
    { value: "Requested by parties we work with", zh: "业务伙伴要求", en: "Requested by parties we work with" },
    {
      value: "Malaysia is an international recognised hub",
      zh: "马来西亚作为国际公认的枢纽，以马来西亚为跳板进行海外业务扩展",
      en: "Malaysia is an international recognised hub",
    },
    { value: "Others, please specify", zh: "其他方式，请列明", en: "Others, please specify" },
  ],
};
